import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  shouldCreateUtilization: true,
  afterCreate(room, server) {
    if (room.shouldCreateUtilization) {
      server.create('graphql/room-utilization', {
        room,
        percentUtilized: faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      });
    }
  },
});
